import PropTypes from 'prop-types';

export const SPOT_IMAGES = PropTypes.arrayOf(
    PropTypes.shape({
        id: PropTypes.string,
        alt: PropTypes.string,
    })
);
